import { render } from "./HomeCalculatorIcon.vue?vue&type=template&id=05f42fb8"
import script from "./HomeCalculatorIcon.vue?vue&type=script&lang=js"
export * from "./HomeCalculatorIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__